/*
 * @Description: 账户相关类型
 * @Author: erickuang
 * @Date: 2021-08-16 19:23:38
 * @LastEditor: erickuang
 * @LastEditTime: 2021-09-18 10:37:31
 */
export enum AccountStatus {
  NotExist = 0, // 未绑定视频号
  NotApplied = 1, // 未提审（不需要绑定视频号）
  Auditing = 2, // 审核中
  Rejected = 3, // 已拒绝
  Accepted = 4, // 已通过
  Suspended = 5, // 暂停使用
  NotUsed = 6, // 账户被删除
  Frozen = 7, // 账号冻结
  Abnormal = 8, // 账号异常（目前包括待删除、冻结两种状态）
}

export enum AccountType {
  AccountTypeCreator, // 创作者
  AccountTypeJianTongKuan, // 做同款气泡
}

export interface AccountInfo {
  ticket: string;
  status: AccountStatus;
  nextApplyTimestamp: number;
  auditMsg: string;
  type: AccountType;
  capability: {
    [key: string]: boolean;
  }
}

export interface UserInfo {
  name: string;
  citizenNo: string;
  phoneNum: string;
  bank: string;
  province: string;
  city: string;
  account: string;
}

export interface ChannelInfo {
  finderUsername: string;
  nickname?: string;
  nickName?: string;
  headImgURL: string;
  inviter: string;
}

export interface InviteInfos {
  nickname: string;
  headImgURL: string;
  status: AccountStatus;
  denyCount: number;
  finishVideoCount: number;
}

export interface InviteInfo {
  unionID: string;
  code: string;
  count: number;
  passCount: number;
  useCount: number;
  nickname: string;
  headImgURL: string;
  inviteInfos: InviteInfos[];
}

export interface DeleteAccountPreventItem {
  title: string;
  content: string;
}

export const ACCOUNT_STATUS_MAP: {
  [status in AccountStatus]: {
    label: string;
    type: AccountStatus
  }
} = {
  [AccountStatus.NotExist]: {
    label: '未创建',
    type: AccountStatus.NotExist,
  },
  [AccountStatus.NotApplied]: {
    label: '未提审',
    type: AccountStatus.NotApplied,
  },
  [AccountStatus.Accepted]: {
    label: '已通过',
    type: AccountStatus.Accepted,
  },
  [AccountStatus.Auditing]: {
    label: '待审核',
    type: AccountStatus.Auditing,
  },
  [AccountStatus.Rejected]: {
    label: '已拒绝',
    type: AccountStatus.Rejected,
  },
  [AccountStatus.Suspended]: {
    label: '注销中',
    type: AccountStatus.Suspended,
  },
  [AccountStatus.NotUsed]: {
    label: '已注销',
    type: AccountStatus.NotUsed,
  },
  [AccountStatus.Frozen]: {
    label: '已冻结',
    type: AccountStatus.Frozen,
  },
  [AccountStatus.Abnormal]: {
    label: '账号异常',
    type: AccountStatus.Abnormal,
  },
};
